<template>
  <div class="effect-setting" :style="{left: active ? 0 : '100%'}">
    <StayEffect v-if="hasStay" :updateData="updateData" @changeData="initData" />
    <EnterEffect
      :updateData="updateData"
      :enterArr="enterArr"
      :enterCode="enterCode"
      :special="special"
      @changeData="initData"
    />
    <ExitEffect 
      :updateData="updateData"
      :exitArr="exitArr"
      :exitCode="exitCode"
      @changeData="initData"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StayEffect from './stayEffect.vue'
import EnterEffect from './enterEffect.vue'
import ExitEffect from './exitEffect.vue'

export default {
  props: {
    active: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data() {
    let enterCommon = [
      'None',
      'Slide',
      'LeftIn',
      'RightIn',
      'DownIn',
      'UpIn',
      'PopIn',
      'FadeIn',
      'Smear'
    ];
    return {
      updateData: 0,
      hasStay: false,
      stype: '',
      enterArr: [],
      enterCode: '',
      exitArr: [],
      exitCode: '',
      special: {
        artText: false,
        stayEff: false
      }
    }
  },
  computed: {
    ...mapGetters([
      "SelectSprites_Msg",
    ])
  },
  watch: {
    'active': function() {
      this.initData();
    },
    'SelectSprites_Msg': function() {
      this.initData()
    }
  },
  mounted() {
    this.initData();
    this.$bus.on("undoRedoHandle", this._undoRedoHandle);
    this.$bus.on("updateEffect_vue", this.upadteEffect_vue);
  },
  methods: {
    initData() {
      if(!this.active) return;
      let len = this.SelectSprites_Msg.length
      if(len > 1) {
        this.hasStay = false;
      } else {
        this.hasStay = true;
      }
      let ts = new Set();
      let enter = new Set();
      let exit = new Set();
      this.special.artText = false;
      this.special.stayEff = false;
      for(let i = 0; i < len; i++ ) {
        let s = this.SelectSprites_Msg[i];
        ts.add(s.type);
        enter.add(s.effect.code)
        exit.add(s.effect.exitAnim.type)
        if(s.artType && s.artControl && s.artControl.length) this.special.artText = true;
        if(s.effect.pathAnim.target || s.effect.stayAnim.type !== 'None') this.special.stayEff = true;
      }
      this.initArr();
      let enterEffect = {
        Image: [7],
        Svg: [6, 7],
        Text: [1, 2, 3, 4, 5]
      }
      if(ts.size === 2) {
        if(ts.has('Image') && ts.has('Svg')) {
          this.enterArr[7].show = true;
          if(this.special.artText || this.special.stayEff) this.enterArr[7].disabled = true;
        }
      } else if(ts.size === 1) {
        let type = ts.values().next().value;
        if(enterEffect[type]) {
          enterEffect[type].forEach(v => {
            this.enterArr[v].show = true;
            if(this.special.artText || this.special.stayEff) this.enterArr[v].disabled = true;
          })
        } 
      }
      let it = null;
      if(enter.size === 1) {
        it = enter.values();
        this.enterCode = it.next().value;
      } else {
        this.enterCode = '';
      }
      if(exit.size === 1) {
        it = exit.values();
        this.exitCode = it.next().value;
      } else {
        this.exitCode = '';
      }
      
      let canHand = ['Slide', 'Hand', 'Draw', 'Write', 'LeftIn', 'RightIn', 'DownIn', 'UpIn', 'RightOut', 'LeftOut', 'UpOut', 'DownOut']
      this.updateData++;
    },
    initArr() {
      this.enterArr = [
        {text: '无动画', type: 'None', disabled: false, show: true, alias: 'noAnim'},
        {text: '书写', type: 'Write', disabled: false, show: false, alias: 'write'},
        {text: '逐行', type: 'Appear', disabled: false, show: false, alias: 'appear'},
        {text: '打字', type: 'Type', disabled: false, show: false, alias: 'type'},
        {text: '翻滚', type: 'Roll', disabled: false, show: false, alias: 'roll'},
        {text: '弹跳', type: 'Bounce', disabled: false, show: false, alias: 'bounce'},
        {text: '手绘', type: 'Hand', disabled: false, show: false, alias: 'hand'},
        {text: '涂抹', type: 'Draw', disabled: false, show: false, alias: 'write'},
        {text: '移入', type: 'Slide', disabled: false, show: true, alias: 'slide'},
        {text: '放大', type: 'PopIn', disabled: false, show: true, alias: 'pop'},
        {text: '淡入', type: 'FadeIn', disabled: false, show: true, alias: 'fade'},
        {text: '擦入', type: 'Smear', disabled: false, show: true, alias: 'smear'}
      ],
      this.exitArr = [
        {text: '无动画', type: 'None', disabled: false, show:true, alias: 'noAnim'},
        {text: '移出', type: 'Slide', disabled: false, show:true, alias: 'slide'},
        {text: '缩小', type: 'PopOut', disabled: false, show:true, alias: 'pop'},
        {text: '淡出', type: 'FadeOut', disabled: false, show:true, alias: 'fade'},
        {text: '擦出', type: 'Smear', disabled: false, show:true, alias: 'smear'},
      ]
    },
    upadteEffect_vue(data) {
      if(data && data.type !=='exitEffect') {
        this.initData();
      }
    },
    _undoRedoHandle({type}) {
      if (type === "updateEffects") {
        this.initData();
      }
    }
  },
  beforeDestroy() {
    this.$bus.off("undoRedoHandle", this._undoRedoHandle)
    this.$bus.on("updateEffect_vue", this.upadteEffect_vue);
  },
  components: {
    StayEffect,
    EnterEffect,
    ExitEffect
  }
}
</script>

<style lang="scss" scoped>
.effect-setting {
  position: absolute;
  top: 0;
  left: 0;
  width: 226px;
  color: #737596;
  transition: all 0.3s;
}
</style>


// WEBPACK FOOTER //
// src/components/settingPanel/effectSetting.vue